module.exports = __webpack_public_path__ + "services_bg.55f456d74293c310318b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services_bg.png
// module id = 472
// module chunks = 1